import { FC } from 'react';

import { Arrow, ToggleLayer } from 'react-laag';

import Dropdown from 'components/shared/Dropdown';
import Icon from 'components/shared/Icon';
import Pencil from 'components/shared/Icon/icons/Pencil';
import ThreeDots from 'components/shared/Icon/icons/ThreeDots';
import Trash2 from 'components/shared/Icon/icons/Trash2';

import s from './index.module.css';
import { IEventActionMenuProps } from './types';

export const EventActionMenu: FC<IEventActionMenuProps> = ({ onClick, onDelete, onEdit }) => (
  <ToggleLayer
    fixed
    renderLayer={({ isOpen, layerProps, arrowStyle, layerSide }) =>
      isOpen && (
        <div
          ref={layerProps.ref}
          className="layer"
          style={{
            ...layerProps.style,
            zIndex: 1300,
          }}
        >
          <Dropdown className={s.actionsMenuWrapper}>
            <div className={s.actionsMenuList}>
              <div className={s.actionsMenuOption} onClick={onEdit}>
                <Icon component={Pencil} stroke="#3F3C43" width="22px" height="22px" />
                <div className={s.actionsMenuOptionText}>Edit</div>
              </div>
              <div className={s.actionsMenuOption} onClick={onDelete}>
                <Icon component={Trash2} stroke="#3F3C43" width="22px" height="22px" />
                <div className={s.actionsMenuOptionText}>Delete</div>
              </div>
            </div>
          </Dropdown>
          <Arrow
            style={{ ...arrowStyle, zIndex: '21' }}
            layerSide={layerSide}
            borderWidth={1}
            borderColor="rgba(0, 0, 0, 0.04)"
            backgroundColor="#fff"
            angle={45}
            roundness={0.5}
            size={10}
          />
        </div>
      )
    }
    placement={{
      anchor: 'BOTTOM_CENTER',
      autoAdjust: true,
      triggerOffset: 10,
    }}
    onOutsideClick={() => {
      onClick();
    }}
    closeOnOutsideClick
  >
    {({ triggerRef, toggle }) => {
      return (
        <button
          type="button"
          className={s.actionsMenuButton}
          ref={triggerRef}
          onClick={() => {
            toggle();
            onClick();
          }}
        >
          <Icon component={ThreeDots} width="14px" height="14px" />
        </button>
      );
    }}
  </ToggleLayer>
);
